module.exports = __webpack_public_path__ + "img/chubbhogar-4-full.febee7f3.png";